var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph_card",attrs:{"id":"graph_contextmenu"}},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,on:{"click":function($event){_vm.runMethod(item.ref);_vm.menu.style.display='none'}}},[_c('GraphSVG',{attrs:{"name":item.icon}}),_c('span',[_vm._v(_vm._s(item.text))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }